<template>
  <a :href="result.detailPage" class="blog-search-item">
    <DefImg :result="result.picture" />
    <span class="blog-search-item__name">
      {{ result.name }}
    </span>
  </a>
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';

export default {
  name: 'BlogSearchItem',
  components: { DefImg },
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.blog-search-item {
  display: grid;
  grid-template-columns: 64px 1fr;
  grid-column-gap: 8px;
  align-items: center;
  background-color: #fff;
  @include point-lg {
    grid-template-columns: 80px 1fr;
    grid-column-gap: 10px;
  }
  &__name {
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    @include point-md {
      font-size: 14px;
    }
  }
}
</style>